import { Steart } from 'app/models/core/steart.model';
import { ZeWidgetDef, ZeWidgetItem } from './vbl.ze.widgets';

export const UbZeWidgets: ZeWidgetDef[] = [
	new ZeWidgetDef({
		title: 'Leben Firmen und Leben Firmen Risiko',
		key: 'ZE_LebenFirmenRisiko_UB',
		subTitle: 'Bewertung ohne ZE',
		stearts: [Steart.UB],
		items: [
			new ZeWidgetItem({
				text: <strong>Summe der Zielerfüllungen im individuellen Arbeitsgebiet 190%</strong>,
				posId: 2230045,
				einheit: '%',
			}),
			new ZeWidgetItem({
				text: <strong>Mindestens in Leben Firmen 90%</strong>,
				posId: 2230041,
			}),
			new ZeWidgetItem({
				text: <strong>Mindestens in Leben Firmen Risiko 90%</strong>,
				posId: 2230043,
			}),
		],
	}),

	new ZeWidgetDef({
		title: 'oder Leben Firmen',
		key: 'ZE_LebenFirmen_UB',
		subTitle: 'Anzahl GV/HV mit mindestens 40.000 Bewertung ohne ZE',
		stearts: [Steart.UB],
		items: [
			new ZeWidgetItem({
				text: <strong></strong>,
				posId: 2230046,
			}),
		],
	}),
];
